import { ShortAlertResponse } from 'app/modules/alerts/types/responses';

import { INSTRUMENT_QUERY_KEYS } from 'app/modules/instruments/queries/keys';

import { post } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { PaginationPayload } from 'app/shared/pagination/models';
import { useSelector } from 'react-redux';
import { selectDLEnabledForInstrumentDetail } from 'app/shared/featureFlags/selectors';

export const useInstrumentAlerts = (
  instrumentExternalId: string,
  payload: PaginationPayload,
  enabled?: boolean,
) => {
  const useCacheEndpoint = useSelector(selectDLEnabledForInstrumentDetail);
  return useQuery({
    queryFn: () => {
      if (useCacheEndpoint) {
        return post<{ count: number; alerts: ShortAlertResponse[] }>(
          `/alerts/cached/list`,
          {
            ...payload,
            instrument_external_ids: [instrumentExternalId],
          },
        );
      }
      return post<{ count: number; alerts: ShortAlertResponse[] }>(
        `/instruments/${instrumentExternalId}/paginated-alerts`,
        payload,
      );
    },
    queryKey: INSTRUMENT_QUERY_KEYS.getInstrumentAlerts(
      instrumentExternalId,
      payload,
      useCacheEndpoint,
    ),
    enabled: !!instrumentExternalId && enabled,
  });
};
